module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-main', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "not-found"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "data-qa": "Content-Logo-Image",
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "xs": 20,
      "sm": 16,
      "md": 16,
      "lg": 8
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('notFoundTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('notFoundDescription')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons-block"
  }, [_c('a', {
    attrs: {
      "href": _vm.goSupportPage
    }
  }, [_c('el-button', {
    staticClass: "support-button",
    style: ({
      '--button-color': _vm.backgroundColor
    }),
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('notFoundButtonSupportText')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fccb24ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound/NotFound.vue
// module id = 989
// module chunks = 3